// Using window as function makes mocking easier
export const windowGlobal = () => window
